import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-banner-background-svg',
  templateUrl: './alert-banner-background-svg.component.html',
  styleUrls: ['./alert-banner-background-svg.component.scss']
})
export class AlertBannerBackgroundSvgComponent {
}
